/** Auswählbare Minuten je Monteur: 15–60 in 5er-, danach bis 480 in 15er-Schritten. */
export const MONTAGE_MINUTEN = [
    ...Array.from({ length: 10 }, (_, i) => 15 + i * 5),
    ...Array.from({ length: 28 }, (_, i) => 75 + i * 15),
];
export const MONTAGE_PERSONEN_MAX = 20;
export const MONTAGEPRODUKT_NAME_MAX = 200;
const FEHLER_MINUTEN = "Minuten müssen zwischen 15 und 480 liegen (bis 60 in 5er-, danach in 15er-Schritten).";
/** Prüft ein Montageprodukt; `wert.name` ist getrimmt, die Staffel bleibt unverändert. */
export function pruefeMontageprodukt(e) {
    const name = e.name.trim();
    if (!name)
        return { fehler: "Bitte eine Bezeichnung angeben." };
    if (name.length > MONTAGEPRODUKT_NAME_MAX) {
        return { fehler: `Die Bezeichnung darf höchstens ${MONTAGEPRODUKT_NAME_MAX} Zeichen lang sein.` };
    }
    const staffel = e.staffel;
    if (staffel.length === 0)
        return { fehler: "Bitte mindestens eine Stufe angeben." };
    if (staffel[0].abMm !== 0)
        return { fehler: "Die erste Stufe muss bei 0 mm beginnen." };
    for (const stufe of staffel) {
        if (!Number.isInteger(stufe.abMm) || stufe.abMm < 0) {
            return { fehler: "„ab mm“ muss eine ganze Zahl ab 0 sein." };
        }
        if (!MONTAGE_MINUTEN.includes(stufe.minuten))
            return { fehler: FEHLER_MINUTEN };
        if (!Number.isInteger(stufe.personen) || stufe.personen < 1 || stufe.personen > MONTAGE_PERSONEN_MAX) {
            return { fehler: `Personen müssen eine ganze Zahl von 1 bis ${MONTAGE_PERSONEN_MAX} sein.` };
        }
    }
    for (let i = 1; i < staffel.length; i++) {
        if (staffel[i].abMm <= staffel[i - 1].abMm) {
            return { fehler: "Die Stufen müssen nach „ab mm“ aufsteigend sein, ohne doppelte Werte." };
        }
    }
    return { wert: { name, staffel } };
}
/** Arbeitszeit gesamt: Minuten je Monteur mal Monteure. */
export function arbeitszeitMinuten(s) {
    return s.minuten * s.personen;
}
/** „45 min“, „1 h“, „2 h 30 min“. */
export function dauerText(minuten) {
    const h = Math.floor(minuten / 60);
    const m = minuten % 60;
    if (h === 0)
        return `${m} min`;
    return m === 0 ? `${h} h` : `${h} h ${m} min`;
}
/** „ab 2.500 mm: 2 h 30 min · 3 P.“ */
export function stufeText(s) {
    return `ab ${s.abMm.toLocaleString("de-DE")} mm: ${dauerText(s.minuten)} · ${s.personen} P.`;
}
export function staffelKurz(staffel) {
    return staffel.map(stufeText).join(" · ");
}
/** „1 h · 2 Monteure = 2 h Arbeitszeit“ */
export function arbeitszeitText(s) {
    const monteure = s.personen === 1 ? "Monteur" : "Monteure";
    return `${dauerText(s.minuten)} · ${s.personen} ${monteure} = ${dauerText(arbeitszeitMinuten(s))} Arbeitszeit`;
}
//# sourceMappingURL=montage.js.map